$(function() {

	if ( "undefined" !== typeof $.fn.datepicker && "undefined" !== typeof $.fn.datepicker.noConflict ) {
		var datepicker = $.fn.datepicker.noConflict();
		$.fn.bootstrapDatepicker = datepicker;
	}

	var wrapper = $('.booking_experience');
	var calendars = wrapper.find('.calendars_panel');
	var dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	var bookingExperienceLaunchers = $('');
	var bookingBar = $('.booking_bar.hold');
	var mobileBookingButtons = $('');
	var arriveHeader = wrapper.find('.arrive');
	var departHeader = wrapper.find('.depart');
	var guestsHeader = wrapper.find('.guests');
	var bookingWindow = wrapper.find('.booking_window');
	var guestButtons = wrapper.find('.guests_panel button');
	var topScroll = 0;
	var bookingExperienceBookButton = $('#book_now.hold');
	var close = $('#close_booking_experience, button.close');
	var nextStep = wrapper.find('#booking_next');
	var prevStep = wrapper.find('#booking_prev');
	var ourDate = new Date();
	var today = {day: ourDate.getDate(), month: ourDate.getMonth()+1, year: ourDate.getFullYear()};
	var displayedDate = $.extend({},today);
	var triggeredRefresh = false;
	var arriveDate = null;
	var departDate = null;
	var guests = 2;
	var stopClick = false;

	var dateSuffix = '';
	var guestSuffix = '';

	language = $('html').attr('lang');

	var getLinkerParam = function(joinChar) {
		//get CID
		var linkerParam = "";
		ga(function() {
			if (typeof ga !== 'undefined') {
				var tracker = ga.getAll()[0];
	
				if (typeof tracker !== 'undefined') {
					var linkerParam = tracker.get('linkerParam');
				}
			}
			return joinChar + linkerParam;
		})
		return linkerParam
	}

	var bookingUrl = 'https://be.synxis.com/?Hotel=79928&Chain=10237'
	var mobileBookingUrl = 'https://be.synxis.com/?Hotel=79928&Chain=10237';


	mobileBookingButtons.on("click keydown", function(e){
		var keycode = (e.keyCode ? e.keyCode : e.which);

		if ($(window).width() <= 1025  || keycode == '13') {
			window.location.href = mobileBookingUrl + getLinkerParam('?');
		}
	});

	if ($(window).width() > 1025 ) {

		var onUpdateDatepicker = function(inst) {
			updateDatePicker();

			if (!inst || triggeredRefresh) {
				triggeredRefresh = false;
				return;
			}

			if (inst.id == 'booking_calendar_1') {
				triggeredRefresh = true;
				second.datepicker('refresh');
			} else if (inst.id == 'booking_calendar_2') {
				triggeredRefresh = true;
				first.datepicker('refresh');
			}


		}

		var updateDatePicker = function() {
			updateChosenDays();
			labelPastDays(first);
			labelPastDays(second);
			if (arriveDate) {
				arriveHeader.find('.date').text(' ' + $.datepicker._defaults.monthNamesShort[arriveDate.month-1] + ' ');
				arriveHeader.find('.num').text(arriveDate.day + dateSuffix);

				var cloned = $.extend({}, arriveDate);
				var nextDay = buildDateString(cloned, false);

				departHeader.find('.date').text(' ' + $.datepicker._defaults.monthNamesShort[moment(nextDay).add(1, 'day').format('M')-1] + ' ');
				departHeader.find('.num').text(moment(nextDay).add(1, 'day').format('D') + dateSuffix);
			}

			if (departDate) {
				departHeader.find('.date').text(' ' + $.datepicker._defaults.monthNamesShort[departDate.month-1] + ' ');
				departHeader.find('.num').text(departDate.day + dateSuffix);
			}
		}

		var onSelect = function(date, picker) {
			if (stopClick) {
				stopClick = false;
				return;
			}
			date = splitDate(date);

			if (date.magnitude < today.magnitude)
				return;

			if (arriveDate && departDate) {
				departDate = null;
				arriveDate = date;
				step_2();
				return;
			}

			if (arriveDate && date.magnitude < arriveDate.magnitude) {
				departDate = arriveDate;
				arriveDate = date;
				step_3();
				return;
			}

			if (!arriveDate) {
				arriveDate = date;
			} else {
				departDate = date;
			}

			if (!arriveDate) {
				step_1();
			} else if (!departDate) {
				step_2();
			} else {
				step_3();
			}
		}

		function updateChosenDays() {
			// We want first day to be grey unless we're showing an orange range of days.
			if (arriveDate && departDate)
				first.find('.ui-datepicker-today.active-day').addClass('today-active');

			if (arriveDate) {
				getDayElement(arriveDate).addClass('active-day');
			}

			if (departDate) {
				getDayElement(departDate).addClass('active-day');
			}

			if (arriveDate && departDate) {
				var betweenDate = jQuery.extend({}, arriveDate);
				var limitCount = 0;
				var limit = 100;
				while (getDateMagnitude(betweenDate) < departDate.magnitude && limitCount < limit) {
					limitCount += 1;
					betweenDate.day += 1;
					var element = getDayElement(betweenDate);
					element.addClass('active-day');
					if (!element.length) {
						betweenDate.day = 0;
						betweenDate.month += 1;
						if (betweenDate.month > 12) {
							betweenDate.month = 1;
							betweenDate.year += 1;
						}
					}
				}
			}
		}

		function getDayElement(date) {
			// Subtract 1 because the attribute jquery sets is a 0 index.
			var dayElement = calendars.find('td:contains(' + date.day + ')[data-month=' + (date.month-1) + ']');
			var filtered = [];
			dayElement.each(function() {
				if (parseInt($(this).text()) == date.day) {
					filtered.push(this);
				}
			});
			return $(filtered);
		}

		function splitDate(date) {
			var split = date.split('/');
			if (language == 'ja') {
				date = {month: parseInt(split[1]), day: parseInt(split[2]), year: parseInt(split[0])};
				date.magnitude = getDateMagnitude(date);
			} else {
				date = {month: parseInt(split[0]), day: parseInt(split[1]), year: parseInt(split[2])};
				date.magnitude = getDateMagnitude(date);
			}
			return date;
		}

		// Get a number representing which date comes before/after other dates.
		function getDateMagnitude(date) {
			function pad(num, size) {
				var s = "000000000" + num;
				return s.substr(s.length-size);
			}
			var magnitude = parseInt(date.year + pad(date.month, 2) + pad(date.day, 2));
			return magnitude;
		}

		function labelPastDays(calendar) {
			var today = calendar.find('.ui-datepicker-today');
			if (!today.length)
				return;
			var calendarDays = calendar.find('td');
			var previousDays = [];

			for (var i=0; i<calendarDays.length; i++) {
				if (calendarDays.eq(i)[0] == today[0]) {
					break;
				}
				previousDays.push(calendarDays[i]);
			}

			$(previousDays).addClass('past');
		}

		// Make past days not respond to clicks
		$('.calendars_panel').on('mousedown', '.past', function(e) {
			stopClick = true;
			e.stopPropagation();
			e.preventDefault();
			return false;
		});

		if (language == 'ja') {
			$.datepicker.setDefaults($.datepicker.regional['ja']);
		} else {
			$.datepicker.regional[''].dayNamesMin = dayNames;
			$.datepicker.setDefaults($.datepicker.regional['']);
		}

		var first = $('#booking_calendar_1').datepicker({
			onSelect: onSelect,
			// dayNamesMin: dayNames,
			minDate: new Date(2017, 10 - 1, 1),
		});
		var second = $('#booking_calendar_2').datepicker({
			onSelect: onSelect,
			minDate: new Date(2017, 11 - 1, 1),
			defaultDate: '+1m',
			// dayNamesMin: dayNames
		});


		function highlightInitialDays() {
			var dayElements = first.find('td:not(.ui-datepicker-unselectable)');
			dayElements.each(function(i) {
				// if ($(this).hasClass('ui-datepicker-current-day')) {
				// 	$(this).trigger('click');
					// Commented code was for selecting the next available day. We changed how this works.
					// dayElements = first.find('td:not(.ui-datepicker-unselectable)');
					// if (dayElements.eq(i+1).length) {
					// 	dayElements.eq(i+1).trigger('click');
					// } else {
					// 	second.find('td:not(.ui-datepicker-unselectable)').eq(0).trigger('click');
					// }
				// }
			});
		}

		arriveHeader.click(step_1);
		departHeader.click(step_2);
		guestsHeader.click(step_4);

		function step_1() {
			wrapper.find('.guests, .arrive, .depart').addClass('disabled');
			wrapper.find('.arrive').removeClass('disabled');
			bookingWindow.addClass('show_calendar').removeClass('show_guests');
			updateDatePicker();
		}

		function step_2() {
			wrapper.find('.guests, .arrive, .depart').addClass('disabled');
			wrapper.find('.depart').removeClass('disabled');
			bookingWindow.addClass('show_calendar').removeClass('show_guests');
		}

		function step_3() {
			wrapper.find('.guests, .arrive, .depart').addClass('disabled');
			wrapper.find('.guests').removeClass('disabled');
		}

		function step_4() {
			wrapper.find('.guests, .arrive, .depart').addClass('disabled');
			wrapper.find('.guests').removeClass('disabled');
			bookingWindow.removeClass('show_calendar').addClass('show_guests');
		}

		function incrementDate(date) {
			date.day = 1;
			date.month += 1;
			if (date.month == 13) {
				date.month = 1;
				date.year += 1;
			}
		}

		function decrementDate(date) {
			date.day = 1;
			date.month -= 1;
			if (date.month == 0) {
				date.month = 12;
				date.year -= 1;
			}
		}

		function buildDateString(date, localized) {
			if (language == 'ja' && localized) {
				var dateString = date.year + '/' + date.month + '/' + date.day;
			} else {
				var dateString = date.month + '/' + date.day + '/' + date.year;
			}
			return dateString;
		}

		function getLengthOfStay(arrival, departure){
			var msPerDay = 1000 * 60 * 60 * 24;
			arriveDate = new Date(arrival.year, arrival.month-1, arrival.day);
			departDate = new Date(departure.year, departure.month-1, departure.day);
			var milli_secs = departDate.getTime() - arriveDate.getTime();
		  
			return Math.floor(milli_secs / msPerDay);
		}

		nextStep.click(function() {
			incrementDate(displayedDate);
			var cloned = $.extend({}, displayedDate);
			var dateString1 = buildDateString(displayedDate, true);
			incrementDate(cloned);
			var dateString2 = buildDateString(cloned, true);
			first.datepicker("setDate", dateString1);
			second.datepicker("setDate", dateString2);
			prevStep.removeClass('hide');
			return false;
		});

		prevStep.click(function() {
			decrementDate(displayedDate);
			if (today.month == displayedDate.month && today.year == displayedDate.year)
				prevStep.addClass('hide');
			var cloned = $.extend({}, displayedDate);
			var dateString1 = buildDateString(displayedDate, true);
			incrementDate(cloned);
			var dateString2 = buildDateString(cloned, true);
			first.datepicker("setDate", dateString1);
			second.datepicker("setDate", dateString2);
			return false;
		});

		guestButtons.click(function() {
			guestButtons.removeClass('selected');
			guests = $(this).text();
			$(this).addClass('selected');
			wrapper.find('.guests .num').text(guests + guestSuffix);
			return false;
		});

		bookingExperienceBookButton.click(function() {
			var builtBookingUrl = bookingUrl;
			var promoCode = $('#promo').val();
			var groupCode = $('#group').val();

			builtBookingUrl += '&adult=' + guests;

			if (language == 'ja')
				builtBookingUrl += '&locale=ja';

			if (promoCode)
				builtBookingUrl += '&promo=' + promoCode;
			
			if (groupCode)
				builtBookingUrl += '&group=' + groupCode;

			if (arriveDate){
				builtBookingUrl += '&arrive=' + arriveDate.year + '-' + arriveDate.month + '-' + arriveDate.day;
			} else {
				arriveDate = new Date(today.year, today.month, today.day);
				arriveDate = {day: arriveDate.getDate(), month: arriveDate.getMonth(), year: arriveDate.getFullYear()};
				builtBookingUrl += '&arrive=' + arriveDate.year + '-' + arriveDate.month + '-' + arriveDate.day;
			}

			if (departDate){
				departDate = new Date(departDate.year, departDate.month, departDate.day);
				departDate = {day: departDate.getDate(), month: departDate.getMonth(), year: departDate.getFullYear()};
				builtBookingUrl += '&depart=' + departDate.year + '-' + departDate.month + '-' + departDate.day;
			} else {
				departDate = new Date(arriveDate.year, arriveDate.month, arriveDate.day+1);
				departDate = {day: departDate.getDate(), month: departDate.getMonth(), year: departDate.getFullYear()};
				builtBookingUrl += '&depart=' + departDate.year + '-' + departDate.month + '-' + departDate.day;
			}

			try {
				_gatag.xlink(builtBookingUrl + getLinkerParam('&'));
			} catch (e) {
				window.location = builtBookingUrl + getLinkerParam('&');
			}

			closeBookingExperience();
		});

		function closeBookingExperience() {
			$('body').removeClass('modal_open');
			$(window).scrollTop(topScroll);
			$('header').removeClass('booking_experience_open');
			wrapper.removeClass('show start_showing');
			// Delay resetting the step till after the wrapper is hidden
			setTimeout(function() {
				step_1();
			}, 500);
			return false;
		}

		function openBookingExperience(e) {
			if($(e.target).hasClass('my_reservation'))
				return true;

			wrapper.addClass('start_showing');
			arriveHeader.click();
			setTimeout(function() {
				wrapper.addClass('show');
			});
			$('header').addClass('booking_experience_open');
			topScroll = $(window).scrollTop();
			$('.ui-datepicker-today a').get(0).focus();
			$('body').addClass('modal_open');
			return false;
		}

		bookingExperienceLaunchers.click(openBookingExperience);

		close.click(function() {
			closeBookingExperience();
		});

		// Insert an intermediary so we can respond to the datepicker redrawing.
		$.datepicker.__updateDatepicker = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function(inst) {
			$.datepicker.__updateDatepicker(inst);
			onUpdateDatepicker(inst);
		}

		$('[href=#promo]').click(function() {
			$(this).parents('li').siblings().removeClass('show_input')
			$(this).parents('li').addClass('show_input').find('input').focus();
			return false;
		});
		$('#promo_form').submit(function() {
			bookingExperienceBookButton.trigger('click');
			return false;
		});

		$('[href=#group]').click(function() {
			$(this).parents('li').siblings().removeClass('show_input')
			$(this).parents('li').addClass('show_input').find('input').focus();
			return false;
		});
		$('#group_form').submit(function() {
			bookingExperienceBookButton.trigger('click');
			return false;
		});
		// $('[href=#modify]').click(function() {
		// 	$(this).parents('li').siblings().removeClass('show_input')
		// 	$(this).parents('li').addClass('show_input').find('input').first().focus();
		// 	return false;
		// });

		// Init booking bar dates.
		$('.arrive .num').text(' ' + moment().format('D') + dateSuffix);
		$('.arrive .date').text(' ' + $.datepicker._defaults.monthNamesShort[moment().format('M')-1]);
		$('.depart .num').text(' ' + moment().add(1, 'days').format('D') + dateSuffix);
		$('.depart .date').text(' ' + $.datepicker._defaults.monthNamesShort[moment().add(1, 'day').format('M')-1]);

		// bookingBar.find('.arrive .date').text(' ' + $.datepicker._defaults.monthNamesShort[moment().format('M')-1]);
		// bookingBar.find('.depart .date').text(' ' + $.datepicker._defaults.monthNamesShort[moment().add(1, 'day').format('M')-1]);

		updateDatePicker();
		highlightInitialDays();
	}

	$('#my_reservation').submit(function() {
		email = $(this).find('#my_reservation_email').val()
		confirmation_code = $(this).find('#my_reservation_confirmation').val()
		error = $(this).find('.error');

		if(email == "reservations@alohilaniresort.com"){
			error.text('Please enter a valid email address.');
			return false;
		} else {
			error.text();
		}

		existingBooking(email, confirmation_code)
		return false;
	});

	function existingBooking(email, confirmation_code){
		var url = bookingUrl + 'bookings/retrieve?'

		if (email)
			url += 'email=' + email
		if (confirmation_code)
			url += '&confirmation_code=' + confirmation_code

		if (typeof ga != 'undefined') {
			if (typeof ga.getAll == 'function') {
				var tracker = ga.getAll()[0];
				if (typeof tracker != 'undefined') {
					url += '&' + tracker.get('linkerParam');
				}
			}
		}

		var bookingWin = window.open(url, '_blank');
		bookingWin.focus();

		closeBookingExperience();

		return false
	}
});